import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import Login from './Login';
import ResetPasswordPage from './ResetPassword/ResetPasswordPage';

const Routes = (): React.JSX.Element => (
  <Switch>
    <Route exact path="/password-reset/:PasswordToken">
      <ResetPasswordPage />
    </Route>

    <Route
      exact
      path="/"
      render={({ location }) => {
        const { hash } = location;

        return hash ? <Redirect to={hash.replace('#', '')} /> : <Login />;
      }}
    />

    <Route exact path="/login">
      <Login />
    </Route>
    <Route path="*">
      <Redirect to="/" />
    </Route>
  </Switch>
);

export default Routes;
